import { AgGridReact } from "ag-grid-react";
import SearchBox from "components/TableHeader/SearchBox";
import React, { useEffect, useMemo, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import { useFourvenuesHook } from "hooks/fourvenues/useFourvenuesHook";
import { toggleModal } from "store/actions/ui";
import { messageNotification } from "utils/functions";

export default function FourvenuesOrgLookupModal() {
  const dispatch = useDispatch();
  const modal = useSelector((state) => state?.ui);
  const { getOrgList, orgListData, isOrgListLoading } = useFourvenuesHook();
  const [filteredData, setFilteredData] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    if (modal?.modals?.fourvenuesOrgLookup) {
      getOrgList();
    }
  }, [modal?.modals?.fourvenuesOrgLookup]);

  useEffect(() => {
    if (orgListData?.data?.data) {
      const orgData = orgListData.data.data;
      if (search) {
        const filtered = orgData.filter(
          (item) =>
            item.name.toLowerCase().includes(search.toLowerCase()) ||
            item._id.toLowerCase().includes(search.toLowerCase())
        );
        setFilteredData(filtered);
      } else {
        setFilteredData(orgData);
      }
    }
  }, [search, orgListData]);

  const closeModal = () => {
    dispatch(toggleModal(false, "fourvenuesOrgLookup"));
    setSearch("");
  };

  const handleCopyId = (id) => {
    navigator.clipboard.writeText(id).then(
      () => {
        messageNotification("Organization ID copied to clipboard!", "success");
      },
      () => {
        messageNotification("Failed to copy Organization ID", "error");
      }
    );
  };

  const columns = [
    {
      field: "name",
      headerName: "Organization Name",
      flex: 1,
      minWidth: 250,
      sortable: true,
      unSortIcon: true,
    },
    {
      field: "_id",
      headerName: "Organization ID",
      flex: 1,
      minWidth: 350,
      sortable: true,
      unSortIcon: true,
      cellRenderer: function (props) {
        return (
          <div className="d-flex align-items-center justify-content-between w-100">
            <span className="me-3">{props.data._id}</span>
            <a
              href="#"
              className="text-primary d-flex align-items-center"
              onClick={(e) => {
                e.preventDefault();
                handleCopyId(props.data._id);
              }}
              title="Copy Organization ID"
              style={{ minWidth: "24px" }}
            >
              <i className="bx bx-copy fs-18"></i>
            </a>
          </div>
        );
      },
    },
  ];

  const gridStyle = useMemo(() => ({ width: "100%" }), []);
  const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);

  return (
    <Modal
      show={modal?.modals?.fourvenuesOrgLookup}
      onHide={closeModal}
      size="lg"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Fourvenues Organization Lookup</Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-24 py-32">
        <div className="mb-20">
          <SearchBox setSearch={setSearch} search={search} className="mb-0" />
        </div>
        {isOrgListLoading ? (
          <div className="text-center py-4">
            <span>Loading...</span>
          </div>
        ) : (
          <>
            <div style={containerStyle}>
              <div className="ag-theme-custom" style={gridStyle}>
                <AgGridReact
                  columnDefs={columns}
                  rowData={filteredData}
                  suppressCellFocus={true}
                  domLayout="autoHeight"
                  className="ag-theme-alpine"
                />
              </div>
            </div>
            {filteredData.length === 0 && !isOrgListLoading && (
              <div className="text-center mt-3">
                <span>No organizations found</span>
              </div>
            )}
          </>
        )}
      </Modal.Body>
    </Modal>
  );
}
